import styled from '@emotion/styled'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useHistory } from 'react-router-dom'

import Message from '../../App/Components/Message/Message'
import { useAppSelector } from '../../App/Hooks/reduxHooks'
import { Box } from '../../Common/Box'
import { Button } from '../../Common/Button'
import { Layout } from '../../Common/Layout'
import { H1 } from '../../Common/Typography'
import { PackageList } from '../Components/Package/PackageList/PackageList'
import { LargePrice } from '../Components/Price/PackagePrice/LargePrice'

import { IBillingInformation } from './IBillingInformation'
import { InvoiceDataForm } from './InvoiceDataForm'
import { VatForm } from './VatForm'
import {ISubscriptionPlan} from '../interface/ISubscriptionPlan'

const StyledLink = styled(Link)`
  align-self: center;
  margin: -20px 0 32px 0;
`

export const Billing = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const [isSuccess, setIsSuccess] = useState<boolean>(false)

  const chosenPlan: ISubscriptionPlan = useAppSelector(state => state.subscriptionPlan)
  const [billingInformation, setBillingInformation] = useState<
    IBillingInformation | undefined
  >()

  if (!chosenPlan?.title) history.push('/subscription')

  if (isSuccess) {
    return (
      <div className={'page-layout'}>
        <Layout spacing={5} direction={'row'}>
          <Box>
            <div style={{ marginTop: '1em', marginBottom: '1em' }}>
              <Message type={'success'}>{t(`Successfully subscribed`)}</Message>
            </div>
            <Button onClick={() => (window.location.assign('/'))}>
              {t('Start using the application')}
            </Button>
          </Box>
        </Layout>
      </div>
    )
  }

  return (
    <div className={'page-layout large'}>
      <Layout spacing={5} direction={'row'}>
        <Box>
          <H1>{t('Billing information')}</H1>
          {billingInformation ? (
            <InvoiceDataForm
              billingInformation={billingInformation}
              plan={chosenPlan}
              onSuccess={() => setIsSuccess(true)}
            />
          ) : (
            <VatForm
              onVatValidated={(newBillingInformation: IBillingInformation) =>
                setBillingInformation(newBillingInformation)
              }
            />
          )}
        </Box>

        <Box>
          <H1 textAlign={'center'}>{t(chosenPlan.title)}</H1>
          <LargePrice
            packagePrice={`€${chosenPlan.price.nl}/`}
            packageDuration={'m'}
          />
          <StyledLink to={'/subscription'}>{t('Change plan')}</StyledLink>
          <PackageList features={chosenPlan.features} />
        </Box>
      </Layout>
    </div>
  )
}
